import { connect } from 'react-redux';

import InPageSearchDisplay from './needs_refresh_modal.jsx';

import {
  getIsNeedsRefreshDisplayed
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  setIsNeedsRefreshDisplayed
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';


const mapStateToProps = (state) => {
  const isNeedsRefreshDisplayed = getIsNeedsRefreshDisplayed(state);
  return {
    isNeedsRefreshDisplayed
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClose: ()=> {
      dispatch(setIsNeedsRefreshDisplayed(false));
    },
    onRefresh: ()=> {
      window.location.reload(true);
    }
  };
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InPageSearchDisplay);
